export const Roles = {
    Read: 'Read',
    Write: 'Write',
    LabAssistant: 'LabAssistant',
};
export const defaultLabRoles = [Roles.Read];
export const newLabRoles = [Roles.Read, Roles.Write, Roles.LabAssistant];
